import { render, staticRenderFns } from "./Spreads.vue?vue&type=template&id=6afc9844&scoped=true"
import script from "./Spreads.vue?vue&type=script&lang=js"
export * from "./Spreads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afc9844",
  null
  
)

export default component.exports